import AddIcon from "@mui/icons-material/Add";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useLoaderData, useNavigate, useNavigation } from "react-router-dom";
import useDataGridPaging from "../../app/useDataGridPaging";
import { PagedResponse } from "../../types/Result";
import { SystemChat } from "../systemChat/type";
import { systemChatColumns } from "./columns";

export default function SystemChatDataGridLastUnRead() {
  const { logData } = useLoaderData() as { logData: PagedResponse<SystemChat> };
  const navigate = useNavigate();
  const navigation = useNavigation();

  return (
    <>
      <DataGrid
        autoHeight
        sx={{ width: "100%" }}
        rows={logData.data!}
        getRowId={(row) => row.id}
        columns={systemChatColumns}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        loading={navigation.state === "loading"}
        rowCount={logData.totalCount}
        paginationMode="server"
        sortingMode="server"
        filterMode="server"
        pageSizeOptions={[10, 20, 50, 100]}
        disableColumnResize
        density="compact"
        slotProps={{
          filterPanel: {
            filterFormProps: {
              logicOperatorInputProps: {
                variant: "outlined",
                size: "small",
              },
              columnInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              operatorInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              valueInputProps: {
                InputComponentProps: {
                  variant: "outlined",
                  size: "small",
                },
              },
            },
          },
        }}
      />
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{ position: "fixed", bottom: 16, right: 3 }}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          icon={<AddIcon />}
          slotProps={{ tooltip: { title: "Yeni" } }}
          onClick={() => navigate("new")}
        />
      </SpeedDial>
    </>
  );
}
